import React from "react";
import PropTypes from 'prop-types'
import { useImperativeHandle, forwardRef, useState } from "react";
import { useMapEvents, Marker } from 'react-leaflet';
import { latLng } from "leaflet";
import { useDispatch, useSelector } from 'react-redux';
import { parseAddress, fetchAddress } from "Components/layout/container/map/util";

function isPinWithinBounds(projectArea, pinLatLng) {
    return pinLatLng.distanceTo(latLng(projectArea.center_point_latitude, projectArea.center_point_longitude)) / 1000 < projectArea.radius;
}

const PlaceablePin = forwardRef((props, ref) => {

    const dispatch = useDispatch();
    const [position, setPosition] = useState(null);
    const isModalVisible = useSelector((state) => state.addPinModal.isModalVisible);

    const map = useMapEvents({
        click: async (event) => {
            if (isModalVisible) {
                const latLng = event.latlng;
                placePin(latLng);
            }
        },
    })

    async function placePin(latLng) {

        if (!latLng.lat && !latLng.lng) {
            setPosition(null);
            return;
        }

        const address = await fetchAddress(latLng.lat, latLng.lng);

        if (!props.allowedCountries?.includes(address?.country_code)) {
            return;
        }

        if (props.projectArea && !isPinWithinBounds(props.projectArea, latLng)) {
            return;
        }

        setPosition(latLng);

        const pixelPoint = map.project(latLng); // Convert latLng to pixel coordinates

        if (window.innerWidth < 480) {
            const offsetY = window.innerHeight / 4;
            pixelPoint.y += offsetY;
        }
        else {
            const offsetX = window.innerWidth / 7;
            pixelPoint.x += offsetX;
        }

        const newCenter = map.unproject(pixelPoint); // Convert back to geographic coordinates

        map.flyTo(newCenter, map.getZoom());

        dispatch(props.handleUpdatePin({
            pinLat: latLng.lat,
            pinLng: latLng.lng,
            pinAddress: parseAddress(address)
        }));
    }

    // Make the function placePin available to the parent component
    useImperativeHandle(ref, () => ({ 
        placePin: (lat, lng) => { 
            const latLng = { lat, lng }; 
            placePin(latLng); 
        } 
    })); 

    return position === null ? null : (
        <Marker position={position} />
    )
});

PlaceablePin.propTypes = {
    allowedCountries: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default PlaceablePin;